import { render, staticRenderFns } from "./CharacterInitiativeValue.vue?vue&type=template&id=6895ba4e&lang=pug&"
import script from "./CharacterInitiativeValue.vue?vue&type=script&lang=js&"
export * from "./CharacterInitiativeValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterInitiativeValue.vue"
export default component.exports